import type { ComponentProps } from "react";
import type { ICellRendererParams } from "ag-grid-community";
import { Tag } from "@synthesis/shared-ui";

import type { ServiceProcessVersion } from "../service-detail-page.lib";

const VERSION_STATUS_TAG: Record<ServiceProcessVersion["status"], NonNullable<ComponentProps<typeof Tag>["status"]>> = {
  ACTIVE: "IN_QUEUE",
  ARCHIVED: "NEUTRAL",
};

const VERSION_STATUS_LABEL: Record<ServiceProcessVersion["status"], string> = {
  ACTIVE: "Действующая",
  ARCHIVED: "Архивная",
};

/** Ячейка «Статус» версии процесса: «Действующая» / «Архивная». */
export const VersionStatusCell = (params: ICellRendererParams<ServiceProcessVersion>) => {
  if (!params.data) {
    return null;
  }

  return (
    <Tag size="status" status={VERSION_STATUS_TAG[params.data.status]}>
      {VERSION_STATUS_LABEL[params.data.status]}
    </Tag>
  );
};
